import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "14",
  fill: "currentColor"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12.938 1.944c-1.208 0-2.012-.777-2.012-1.944L6.5.389 2.074 0c0 1.167-.805 1.944-2.012 1.944C-.742 10.89 6.5 14 6.5 14s7.242-3.111 6.438-12.056m-5.1 3.884h1.6v1.385H7.327v.603H9.44v1.396H7.326v1.677H5.672V9.212h-2.19V7.816h2.19v-.603h-2.19V5.828H5.14L2.861 2.044H4.75s1.447 2.583 1.776 3.221c.106-.205 1.79-3.22 1.79-3.22h1.824z" }, null, -1)
  ])))
}
export default { render: render }